/* PMP Warenkorb aufklappen 30.10.2026 (PMP-202610-WARENKORB-AUFKLAPPEN)
   Nach jedem erfolgreichen /cart/add (theme-eigenes Formular, teeinblue, andere Apps) oeffnet sich der Warenkorb
   mit Bestaetigung, Zur-Kasse-Knopf und Weiter-einkaufen. Es wird nichts erneut hinzugefuegt und nicht umgeleitet. */
(function () {
  if (window.pmpWk3010) return; window.pmpWk3010 = true;
  var TX = {
    de: ['Liegt im Warenkorb', 'Weiter einkaufen'], en: ['Added to your cart', 'Continue shopping'], fr: ['C\u2019est dans ton panier', 'Continuer mes achats'],
    it: ['\u00C8 nel carrello', 'Continua lo shopping'], es: ['Est\u00E1 en tu carrito', 'Seguir comprando'], nl: ['Ligt in je winkelwagen', 'Verder winkelen'],
    pl: ['Jest w koszyku', 'Kontynuuj zakupy'], pt: ['Est\u00E1 no carrinho', 'Continuar a comprar'], sv: ['Ligger i varukorgen', 'Forts\u00E4tt handla'],
    da: ['Ligger i kurven', 'Forts\u00E6t med at handle'], fi: ['On ostoskorissa', 'Jatka ostoksia'], cs: ['Je v ko\u0161\u00EDku', 'Pokra\u010Dovat v n\u00E1kupu'],
    sk: ['Je v ko\u0161\u00EDku', 'Pokra\u010Dova\u0165 v n\u00E1kupe'], hu: ['A kos\u00E1rban van', 'V\u00E1s\u00E1rl\u00E1s folytat\u00E1sa'], ro: ['Este \u00EEn co\u0219', 'Continu\u0103 cump\u0103r\u0103turile'],
    bg: ['\u0412 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430 \u0435', '\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438 \u043F\u0430\u0437\u0430\u0440\u0443\u0432\u0430\u043D\u0435\u0442\u043E'],
    el: ['\u0395\u03AF\u03BD\u03B1\u03B9 \u03C3\u03C4\u03BF \u03BA\u03B1\u03BB\u03AC\u03B8\u03B9', '\u03A3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03B1\u03B3\u03BF\u03C1\u03CE\u03BD'],
    hr: ['U ko\u0161arici je', 'Nastavi kupnju'], sl: ['V ko\u0161arici je', 'Nadaljuj nakupovanje'], lt: ['Krep\u0161elyje', 'T\u0119sti apsipirkim\u0105']
  };
  var L = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  var S = TX[L] || TX.de;
  var istAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(String(u || '')); };
  var zuletzt = 0, frisch = false, lauf = 0;
  var st = document.createElement('style');
  st.textContent = '.pmp-cart-ok{display:flex;align-items:center;gap:.5rem;margin:0 0 .8rem;padding:.65rem .9rem;border-radius:12px;background:#E8F4EA;color:#1F5B2E;font:600 15px/1.3 Archivo,sans-serif}' +
    '.pmp-cart-ok::before{content:"\\2713";font-weight:700}' +
    '.pmp-cart-weiter{display:block;width:100%;margin:.5rem 0 0;padding:.5rem;background:none;border:0;color:#5F5A55;font:500 14px/1.3 Archivo,sans-serif;text-decoration:underline;cursor:pointer;text-align:center}' +
    '#CartDrawer .drawer__panel{overflow:hidden}' +
    '#CartDrawer #CartDrawerContent,#CartDrawer .shopify-section-cart-drawer{display:flex;flex-direction:column;flex:1 1 auto;min-height:0;height:100%}' +
    '#CartDrawer .drawer__body{flex:1 1 auto;min-height:0;overflow-y:auto}' +
    '#CartDrawer .drawer__foot{flex:none;background:#fff}' +
    '#CartDrawer .pmp-aktion--warenkorb,#CartDrawer .pmp-cart-code-note,#CartDrawer .cart-summary__note{display:none}';
  document.head.appendChild(st);
  function drawer() { return document.getElementById('CartDrawer'); }
  function istOffen() { var d = drawer(); return !!(d && d.classList.contains('is-open')); }
  function schmuecken() {
    var c = document.getElementById('CartDrawerContent'); if (!c) return;
    var body = c.querySelector('.drawer__body');
    if (frisch && body && !c.querySelector('.pmp-cart-ok') && c.querySelector('[data-cart-item]')) {
      var ok = document.createElement('div'); ok.className = 'pmp-cart-ok'; ok.setAttribute('role', 'status'); ok.textContent = S[0];
      body.insertBefore(ok, body.firstChild);
    }
    var form = c.querySelector('#CartDrawerForm');
    if (form && !form.querySelector('.pmp-cart-weiter')) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pmp-cart-weiter'; b.setAttribute('data-drawer-close', ''); b.textContent = S[1];
      form.appendChild(b);
    }
  }
  document.addEventListener('cart:updated', schmuecken);
  function oeffnen() {
    var nr = ++lauf;
    var P = window.PMP, c = P && P.cart, d = drawer();
    if (!d || !P || !P.drawers || document.body.classList.contains('template-cart')) return;
    frisch = true;
    var fertig = function () { if (nr !== lauf) return; try { P.drawers.open(d); } catch (e) {} schmuecken(); var bd = d.querySelector('.drawer__body'); if (bd) bd.scrollTop = 0; };
    if (c && c.fetchSections && !istOffen()) { c.fetchSections().then(function (s) { c.render(s); fertig(); }).catch(fertig); }
    else fertig();
  }
  function erfolg() {
    var jetzt = Date.now(); if (jetzt - zuletzt < 250) return; zuletzt = jetzt;
    setTimeout(oeffnen, 350);
  }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-drawer-close]')) frisch = false; }, true);
  var of = window.fetch;
  if (of) window.fetch = function (u, o) {
    var url = (u && u.url) || u, p = of.apply(this, arguments);
    if (istAdd(url)) p.then(function (r) { if (r && r.ok) erfolg(); }, function () {});
    return p;
  };
  var XO = window.XMLHttpRequest && XMLHttpRequest.prototype.open;
  if (XO) XMLHttpRequest.prototype.open = function (m, u) {
    if (istAdd(u)) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) erfolg(); });
    return XO.apply(this, arguments);
  };
})();
